/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Hide/Show Announcement Bar based on shop metafield flag
(function () {
  // Your announcement section class:
  var selector = '.section--sections--19403999641824__section_announcement_bar_tWnR87';

  function isDealActive() {
    var meta = document.getElementById('deal-flag');
    return meta && meta.getAttribute('content') === 'true';
  }

  function run() {
    var nodes = document.querySelectorAll(selector);
    if (!nodes.length) return;

    var active = isDealActive();

    nodes.forEach(function (node) {
      node.style.setProperty('display', active ? 'block' : 'none', 'important');
      node.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    // Optional CSS hook on <html>
    document.documentElement.classList.toggle('deal-active', active);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
